import { DOMAIN_URL, PHOTO_URL } from "@zmedia/bm-soccer-ui/constants";

export const buildFacebookShareLink = (url: string) => {
    return (
        'https://www.facebook.com/sharer/sharer.php?u=' +
        DOMAIN_URL +
        url +
        '?utm_source=desktop&utm_medium=facebook&utm_campaign=share'
    );
};

export const buildZaloShareLink = (url: string) => {
    return (
        'https://baomoi.com' +
        url +
        '?utm_source=desktop&utm_medium=zalo&utm_campaign=share'
    );
};


export const buildContentLink = (url: string) => {
    if (!url) return '';
    return 'https://baomoi.com' + url;
};

export function buildPhotoUrl(photoPath: string) {
    return `${PHOTO_URL}/${photoPath}`;
}

export const removeParam = (key: string, sourceURL: string) => {
    var rtn = sourceURL.split("?")[0],
        param,
        params_arr = [],
        queryString = (sourceURL.indexOf("?") !== -1) ? sourceURL.split("?")[1] : "";
    if (queryString !== "") {
        params_arr = queryString.split("&");
        for (var i = params_arr.length - 1; i >= 0; i -= 1) {
            param = params_arr[i].split("=")[0];
            if (param === key) {
                params_arr.splice(i, 1);
            }
        }
        if (params_arr.length) rtn = rtn + "?" + params_arr.join("&");
    }
    return rtn;
}

export const getParamUrl = (name: string, url?: string) => {
    if (!url) url = window.location.href;
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]'); // eslint-disable-line
    const regexS = '[\\?&]' + name + '=([^&#]*)';
    const regex = new RegExp(regexS);
    const results = regex.exec(url);
    return results == null ? null : results[1];
};

export const isAbsoluteLink = (url?: string) => {
    if (typeof url !== 'string') return false;
    return url.includes('https://') || url.includes('http://');
};

export const getQueryString = (
    url: string,
    includeQuestionMark: boolean = true
) => {
    const urlArr = url.split('?');
    if (urlArr.length === 2) {
        return (includeQuestionMark ? '?' : '') + urlArr[1];
    }
    return '';
};

export const getUrlLocation = (value: string) => {
    return value && value !== 'QUANH_BAN'
        ? `/tin-dia-phuong/${value.toLowerCase().replace(/_/g, '-')}.epi`
        : '/tin-dia-phuong.epi';
};

export const isContentDetailUrl = (url: string) => {
    return /[c]\d+(\.epi)/g.test(url);
}

export const isTagUrl = (url: string) => {
    return /tag/g.test(url);
}

export function isSoccerPage() {
    return /\/bong\-da|\/soccer/i.test((window as any).location.pathname);
}

export const isSubDomain = (url: string) => {
    return /baomoi.net.vn|beta.baomoi.com|lite.baomoi.com/g.test(url);
}

